import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import { formatDateTime } from '@formosa/shared/utils/formatDateTime';
import Pagination from '../../components/Pagination';
import {
  EMPTY_OPERATION_LOG_FILTERS,
  buildOperationLogPageParams,
} from './operationLogConstants';

const TABLE_COLUMNS = ['內容', '操作人', 'IP', '操作時間'];

export default function OperationLogPage() {
  const [filters, setFilters] = useState(EMPTY_OPERATION_LOG_FILTERS);
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  async function loadRecords(pageNo = 1, nextFilters = filters) {
    setLoading(true);
    setError('');
    try {
      const data = await adminApi.operationLogPage(
        buildOperationLogPageParams(pageNo, nextFilters)
      );
      setRecords(data?.records || []);
      setPage(data?.current || pageNo);
      setTotalPages(data?.pages || 1);
      setTotal(data?.total ?? 0);
    } catch (err) {
      setError(err.message || '載入失敗');
      setRecords([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadRecords(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function updateFilter(key, value) {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }

  function handleSearch(event) {
    event.preventDefault();
    loadRecords(1, filters);
  }

  function handleReset() {
    const reset = { ...EMPTY_OPERATION_LOG_FILTERS };
    setFilters(reset);
    loadRecords(1, reset);
  }

  return (
    <div className="page-card">
      <div className="section-header">
        <h2>操作日誌</h2>
      </div>

      <form className="filter-bar filter-bar-wrap" onSubmit={handleSearch}>
        <div className="form-field">
          <label htmlFor="opLogAdminName">操作人</label>
          <input
            id="opLogAdminName"
            type="text"
            value={filters.adminName}
            onChange={(e) => updateFilter('adminName', e.target.value)}
            placeholder="請輸入操作人"
          />
        </div>
        <div className="form-field">
          <label htmlFor="opLogOperation">操作內容</label>
          <input
            id="opLogOperation"
            type="text"
            value={filters.operation}
            onChange={(e) => updateFilter('operation', e.target.value)}
            placeholder="內容或用戶 ID"
          />
        </div>
        <div className="form-field">
          <label htmlFor="opLogStart">操作時間起</label>
          <input
            id="opLogStart"
            type="datetime-local"
            value={filters.startTimeInput}
            onChange={(e) => updateFilter('startTimeInput', e.target.value)}
          />
        </div>
        <div className="form-field">
          <label htmlFor="opLogEnd">操作時間迄</label>
          <input
            id="opLogEnd"
            type="datetime-local"
            value={filters.endTimeInput}
            onChange={(e) => updateFilter('endTimeInput', e.target.value)}
          />
        </div>
        <div className="filter-actions">
          <button type="submit" className="btn btn-primary">
            搜尋
          </button>
          <button type="button" className="btn btn-secondary" onClick={handleReset}>
            重置
          </button>
        </div>
      </form>

      {error ? <p className="form-message form-message--error">{error}</p> : null}

      <div className="table-meta">共 {total} 筆</div>

      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              {TABLE_COLUMNS.map((col) => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={TABLE_COLUMNS.length} className="table-empty">
                  載入中…
                </td>
              </tr>
            ) : records.length === 0 ? (
              <tr>
                <td colSpan={TABLE_COLUMNS.length} className="table-empty">
                  無資料
                </td>
              </tr>
            ) : (
              records.map((row) => (
                <tr key={row.id}>
                  <td className="cell-wrap">{row.operation || '—'}</td>
                  <td>{row.adminName || '—'}</td>
                  <td>{row.accessIp || '—'}</td>
                  <td>{formatDateTime(row.accessTime)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        page={page}
        totalPages={totalPages}
        onChange={(next) => loadRecords(next, filters)}
      />
    </div>
  );
}
